import { render, staticRenderFns } from "./CardInstrutor.vue?vue&type=template&id=ad99e98e&scoped=true"
import script from "./CardInstrutor.vue?vue&type=script&lang=js"
export * from "./CardInstrutor.vue?vue&type=script&lang=js"
import style0 from "./CardInstrutor.vue?vue&type=style&index=0&id=ad99e98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad99e98e",
  null
  
)

export default component.exports